export const gridOptions = {
    language: {
        'search': {
            'placeholder': '🔍 Buscar...'
        },
        'pagination': {
            'navigate': (page, pages) => `Pagina ${page} de ${pages}`,
            'page': (page) => `Pagina ${page}`,
            'previous': '⬅️',
            'next': '➡️',
            'showing': 'Mostrando',
            'of': 'de',
            'to': 'hasta',
            'results': () => 'Registros'
        },
        'loading': 'Cargando...',
        'noRecordsFound': 'No hay registros',
        'error': 'Ocurrio un error',
    },
    pagination: { limit: 10 },
    search: true,
    sort: true
};